import { defineComponent as _defineComponent } from 'vue'
import { IMonth } from '@/modules/cash/services/costs';
import { Money } from '@/modules/common/components/Money';
import { SideSheet } from '@/modules/common/components/SideSheet';
import {
  BaseIcon,
  BaseText,
  ChipContext,
  ChipStatus,
  Heading,
  Row
} from '@warrenbrasil/nebraska-web';
import { PropType, computed } from 'vue';

interface DisplayItem {
  label: string;
  value: string;
}

interface Item {
  title: string;
  subtitle?: string;
  value: string;
  hasLine: boolean;
  display: DisplayItem[] | false;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CostSideSheet',
  props: {
  isOpen: Boolean,
  costsDetails: {
    type: Object as PropType<IMonth>,
    default: () => ({})
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props



const items = computed<Item[]>(() => [
  {
    title: 'Pendente inicial',
    subtitle: props.costsDetails.initialPendingDate,
    value: props.costsDetails.initialPendingValue,
    hasLine: false,
    display: false
  },
  {
    title: 'Custos no mês',
    value: props.costsDetails.costs,
    hasLine: true,
    display: [
      {
        label: 'Taxa sobre carteiras',
        value: props.costsDetails.wealthTaxes
      },
      {
        label: 'Taxa sobre trade',
        value: props.costsDetails.provisionedTrade
      },
      {
        label: 'Corretagem',
        value: props.costsDetails.brokerage
      }
    ]
  },
  {
    title: 'Pago no mês',
    value: props.costsDetails.paidValue,
    hasLine: true,
    display: [
      {
        label: 'Cashback',
        value: props.costsDetails.cashBack
      },
      {
        label: 'Resgate em carteiras',
        value: props.costsDetails.wealthReedem
      },
      {
        label: 'Carteira de cobrança',
        value: props.costsDetails.costsWealth
      },
      {
        label: 'Saldo da conta digital',
        value: props.costsDetails.accountAmount
      },
      {
        label: 'Corretagem',
        value: props.costsDetails.brokeragePaid
      }
    ]
  },
  {
    title: 'Pendente final',
    subtitle: props.costsDetails.finalPendingDate,
    value: props.costsDetails.finalPendingValue,
    hasLine: true,
    display: false
  }
]);



return { __sfc: true,props, items, emit, Money, SideSheet, BaseIcon, BaseText, ChipContext, ChipStatus, Heading, Row }
}

})